// Flow B stage 2: what the rules cannot settle. Today: cancellations (a seat on a non-refundable
// flight) and bounced invitations (fix the address, or leave it). Exceptions and extra-badge
// requests arrive with the January customer work.
import React, { useEffect, useState } from "react";
import { api } from "../../lib/api.js";
import { PageHead, Notice, fmtWhen } from "./ui.jsx";

export default function HumanPage({ isAdmin, reload }) {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("all");
  const [fix, setFix] = useState({}); // bounce id -> new email
  const [msg, setMsg] = useState(null);
  const [history, setHistory] = useState(null);
  const load = async () => { try { setItems((await api("/backoffice/queue")).items); } catch (err) { setMsg(err.message); } };
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);

  async function decide(r, decision) {
    const note = window.prompt(decision === "declined" ? "Tell them why (optional):" : "Note for the record (optional):");
    if (note === null) return;
    try { await api(`/backoffice/cancellations/${r.id}/decide`, { method: "POST", body: { decision, note } }); setMsg(`${r.who}: ${decision}.`); await load(); reload?.(); }
    catch (err) { setMsg(err.message); }
  }
  async function readdress(r) {
    const email = (fix[r.id] ?? "").trim();
    if (!email) return;
    try { const res = await api(`/backoffice/invitations/${r.id}/readdress`, { method: "POST", body: { email } }); setMsg(`${r.who}: invitation re-sent to ${res.email}.`); setFix({ ...fix, [r.id]: "" }); await load(); reload?.(); }
    catch (err) { setMsg(err.message); }
  }
  async function leave(r) {
    if (!window.confirm(`Leave ${r.who} without an invitation? The bounced one is withdrawn; you can invite them again later.`)) return;
    try { await api(`/backoffice/invitations/${r.id}/revoke`, { method: "POST", body: {} }); await load(); reload?.(); } catch (err) { setMsg(err.message); }
  }
  async function showHistory() { try { setHistory((await api("/backoffice/cancellations?status=approved")).requests.concat((await api("/backoffice/cancellations?status=declined")).requests)); } catch (err) { setMsg(err.message); } }

  const shown = items.filter(i => tab === "all" || i.type === tab);
  const n = (t) => items.filter(i => i.type === t).length;
  return (
    <>
      <PageHead title="Needs a human" sub="Nothing here was decided by the app. A seat on a flight is a cancellation decision; a bounced email needs an address only a person can supply. Hotel names change without you until the cutoff." />
      <div className="bo-filter-row">
        <div className="lbl">Type</div>
        {[["all", "Everything", items.length], ["cancellation", "Can't travel", n("cancellation")], ["bounce", "Bounced", n("bounce")]].map(([v, l, c]) => (
          <button key={v} className={`bo-pill ${tab === v ? "on" : ""}`} onClick={() => setTab(v)}>{l} <span className="n">{c}</span></button>))}
        <button className="bo-link" style={{ marginLeft: "auto" }} onClick={showHistory}>Decided earlier</button>
      </div>
      {msg && <Notice tone="ok">{msg}</Notice>}
      <div className="bo-table human">
        <div className="bo-th"><div>Type</div><div>Who</div><div>What happened</div><div>Waiting</div><div>Your decision</div></div>
        {shown.map(r => (
          <div className="bo-tr" key={r.id}>
            <div>{r.type === "cancellation" ? <span className="bo-state bad">Can't travel</span> : <span className="bo-state mid">Bounced</span>}</div>
            <div className="name"><b>{r.who}</b>{r.type === "cancellation"
              ? <div className="muted small"><span className="mono">{r.codes}</span> · {r.registrant} · {r.travelMethod === "B" ? "flying" : "driving"}</div>
              : <div className="muted small mono">{r.email}</div>}</div>
            <div className="muted">{r.type === "cancellation" ? (r.detail || "No reason given") : `Could not be delivered${r.detail ? `: ${r.detail}` : ""}`}</div>
            <div className="muted">{fmtWhen(r.at)}</div>
            <div className="actions">
              {r.type === "cancellation" && isAdmin && <><button className="bo-link" onClick={() => decide(r, "approved")}>Approve</button> · <button className="bo-link" onClick={() => decide(r, "declined")}>Decline</button></>}
              {r.type === "bounce" && isAdmin && (
                <div className="fixrow">
                  <input className="bo-num wide" type="email" placeholder="Working address" value={fix[r.id] ?? ""} onChange={e => setFix({ ...fix, [r.id]: e.target.value })} />
                  <button className="bo-btn primary" onClick={() => readdress(r)} disabled={!(fix[r.id] ?? "").includes("@")}>Save and send</button>
                  <button className="bo-link" onClick={() => leave(r)}>Leave it</button>
                </div>
              )}
            </div>
          </div>
        ))}
        {!shown.length && <div className="bo-empty">Nothing here. Change the filter, or carry on.</div>}
      </div>
      {history && (
        <>
          <h2 className="bo-h2">Decided earlier</h2>
          <div className="bo-table human">
            {history.map(h => <div className="bo-tr" key={h.id}><div><span className={`bo-state ${h.status === "approved" ? "ok" : ""}`}>{h.status}</span></div><div className="name"><b>{h.travellerName}</b><div className="muted small mono">{h.codes}</div></div><div className="muted">{h.reason || "—"}{h.note && <div className="small">Note: {h.note}</div>}</div><div className="muted">{fmtWhen(h.decidedAt)}</div><div /></div>)}
            {!history.length && <div className="bo-empty">No decisions yet.</div>}
          </div>
        </>
      )}
    </>
  );
}
